export interface DimensionInfo {
    dimension: string;
    title?: string;
    color: string;
    icon?: string;
}

export const Dimensions: { [dimension: string]: DimensionInfo[] } = {
    Environment: [
        {
            dimension: "web",
            title: "Web",
            color: "#994F7E"
        },
        {
            dimension: "app",
            title: "App",
            color: "rgba(153, 79, 126, 0.2)"
        }
    ]
};
